import { API_URLS } from '@helpers/api';
import brand from '@helpers/brand';
import { Device, until } from '@helpers/media';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import LoadingIndicator from '@stories/Components/LoadingIndicator/LoadingIndicator';
import Dropdown from '@stories/Components/Misc/Dropdown/Dropdown';
import RangeCard from '@stories/Components/RangeCard/RangeCard';
import { rgba } from 'polished';
import qs from 'query-string';
import * as React from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import S from './RangeListing.styles';
const RangeListing = ({ anchorId, initialData, docId }) => {
    const [params, setParams] = useQueryParams(Object.assign({
        docId: withDefault(NumberParam, docId),
    }, ...initialData.filters.map((f) => ({ [f.name]: withDefault(StringParam, '') }))));
    const result = useApi({
        initialData: initialData,
        url: `${API_URLS.getRanges}?${qs.stringify(params)}`,
    });
    const imgSizes = `${until(Device.MobileLarge)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopLarge)} 37.5vw, 601px`;
    return (React.createElement(S.Container, { id: anchorId },
        !!result.data?.filters.length && (React.createElement(S.Filters, null, result.data.filters.map((filter) => (React.createElement(Dropdown, { key: `filter-${filter.name}`, ...filter, onChange: (event) => {
                event.preventDefault();
                setParams({ [filter.name]: event.target.value }, 'pushIn');
            }, activeOption: params[filter.name] }))))),
        React.createElement(S.ResultsContainer, null,
            React.createElement(S.ResultsAmount, null,
                "Showing ",
                React.createElement(S.ResultsCount, null, result.data?.totalCount ?? 0),
                " ranges"),
            React.createElement(S.ResultsWrapper, null,
                result.data?.items.map((item) => (React.createElement(RangeCard, { key: `range-card-${item.id}`, ...item, imgSizes: imgSizes, titleType: "h2" }))),
                result.status === 'loading' && (React.createElement(LoadingIndicator, { bgColor: rgba(brand.green, 0.7), fgColor: brand.white, label: "Loading...", layout: "absolute", alignment: "top" }))))));
};
export default withQueryParams(RangeListing);
